import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    Dispatch,
    SetStateAction,
  } from "react";
  
  interface EnvContextType {
    env: string;
    setEnv:Dispatch<SetStateAction<any>>;
  }
  
  const EnvContext = createContext<
  EnvContextType | undefined
  >(undefined);
  
  export const useEnvContext = () =>
    useContext(
        EnvContext,
    ) as EnvContextType;
  
  export const EnvContextProvider: React.FC<{
    children: ReactNode;
  }> = ({ children }) => {
    const [env, setEnv] = useState<string>("");

  
    const contextValues: EnvContextType = {
      env,
      setEnv,
    };
  
    return (
      <EnvContext.Provider value={contextValues}>
        {children}
      </EnvContext.Provider>
    );
  };
  